import styled from "styled-components";
import { FiDatabase } from "react-icons/fi";
import { publicAsset } from "../utils/publicAsset";

// Where a candidate came from: external → ScoutM8 logo, internal → database icon; anything else renders nothing.
// A real tooltip (not `title`) so it shows at once on hover and focus; the icon inherits currentColor.
// Exported so PlatformMark can reuse the same mark + tooltip look.
export const Tip = styled.span`
  position: absolute;
  bottom: calc(100% + 7px);
  left: 50%;
  transform: translateX(-50%) translateY(3px);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition:
    opacity 0.13s ease,
    transform 0.13s ease,
    visibility 0.13s;
  padding: 5px 9px;
  border-radius: 7px;
  font-size: 11.5px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  letter-spacing: 0.01em;
  z-index: 60;
  /* Inverted pill: --ink-2 and --bg swap places between modes, so this reads
     correctly in both without a per-mode branch. */
  color: var(--bg);
  background: var(--ink-2);
  box-shadow: var(--shadow-md);

  /* Caret. Inherits the pill colour so the two can't drift apart. */
  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 4px solid transparent;
    border-top-color: var(--ink-2);
  }
`;

export const Mark = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${(p) => p.$size}px;
  height: ${(p) => p.$size}px;
  line-height: 0;
  opacity: 0.75;
  transition: opacity 0.13s ease;
  outline: none;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
    border-radius: 3px;
  }

  &:hover,
  &:focus-visible {
    opacity: 1;
  }
  &:hover ${Tip}, &:focus-visible ${Tip} {
    opacity: 1;
    visibility: visible;
    transform: translateX(-50%) translateY(0);
  }
`;

export default function OriginMark({ origin, size = 14 }) {
  if (origin !== "external" && origin !== "internal") return null;
  const isExternal = origin === "external";
  const label = isExternal ? "Sourced by ScoutM8" : "From your database";
  return (
    <Mark $size={size} aria-label={label} role="img" tabIndex={0}>
      {isExternal ? (
        <img src={publicAsset("favicon.png")} alt="" aria-hidden="true" />
      ) : (
        <FiDatabase size={size - 1} aria-hidden="true" />
      )}
      <Tip aria-hidden="true">{label}</Tip>
    </Mark>
  );
}
